

function ContractInvoices ({contractId}) {


    return (
        <div>
            Contract invoices ...
        </div>
    )
}

export default ContractInvoices;